<template>
    <div>
        <transition name="modal">
            <div class="modal-mask">
                <div class="modal-wrapper" data-backdrop="static" data-keyboard="false">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">
                            <div class="modal-header modal-header-color">
                                <h5 class="modal-title" id="footerCenterBtnsModalLabel">{{ t('APP.MODAL.SELECT') }}</h5>
                            </div>
                            <div class="modal-body modal-open modal-height-max">
                                <div class="row gutters">
                                    <div class="col-xl-12 col-lglg-12 col-md-12 col-sm-12 col-12">
                                        <div class="form-group">
                                            <input type="text" name="company" v-model="companyModal" id="company"
                                                   class="form-control mb-2" @keyup="selectCompanyModal"
                                                   placeholder="Digite o nome da companhia para buscar">
                                            <div class="justify-content-center modal-row2">
                                                <div v-for="(company, key) in allCompanies" :key="key">
                                                    <button class="btn btn-background mt-1"
                                                            @click="companyModalSelected(company)">
                                                        {{ company.text }}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import {useI18n} from "vue-i18n";
import {useToast} from "vue-toastification";

export default {
    name: "modalCompany",
    props: {
        loadPermissions: {
            type: Boolean,
            default: false
        }
    },
    emits:['alterPermissions'],
    setup() {
        const {t} = useI18n();
        const toast = useToast();
        return {t, toast}
    },
    data() {
        return {
            companyModal: null,
            allCompanies: JSON.parse(localStorage.getItem('companies')),
            companiesBackup: JSON.parse(localStorage.getItem('companies')),
        }
    },
    methods: {
        formatSearch(str) {
            return (str || "")
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "")
                    .toUpperCase()
                    .trim();
        },
        selectCompanyModal() {
            const textModal = this.formatSearch(this.companyModal);
            this.allCompanies = this.companiesBackup.filter(company => {
                const text = this.formatSearch(company.text);
                return text.includes(textModal);
            });
        },
        companyModalSelected(company) {
            this.companyId = company.id;
            localStorage.removeItem('companyId');
            this.companySelected = company.id;
            this.$store.commit('showModalSelectCompany', false);
            localStorage.setItem('companyId', company.id);
            if (this.loadPermissions) {
                this.$emit('alterPermissions', company)
            } else {
                this.$router.go();
            }
        },
    }
}
</script>
